var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"row":"","wrap":""}},[(_vm.is_list_available)?_c('v-flex',{attrs:{"xs12":""}},[_c('ScreenerList',{attrs:{"list":_vm.todayList,"is_today":true}})],1):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }